import React, { useState, useRef } from "react";
import { useModal } from "hooks";
import locale from "localization";
import styles from "./competitor-edit.module.scss";
import { FormMode } from "enums";
import { Path } from "enums";
import { Intro, BackLink } from "components/commons";
import CompetitorDetailsModule from "../competitor-details/competitor-details.module";
import { useHistory } from "react-router-dom";

const CompetitorEditModule = (props) => {
  const competitorDetailsRef = useRef();
  const successModal = useModal();
  const [updateLoading, setUpdateLoading] = useState(false);
  const [disableUpdate, setDisableUpdate] = useState(false);
  const history = useHistory();
  const brandId = props.location.state ? props.location.state.brandId : "";
  const updatedAt = props.location.state ? props.location.state.updatedAt : "";

  return (
    <div>
      <BackLink text={locale.competitorList} path={Path.CompetitorList} />
      <div className={styles.intro}>
        <Intro
          title={locale.editCompetitorDetails}
          actionText={locale.save}
          actionOnClick={() => {
            competitorDetailsRef.current.handleUpdate();
          }}
          actionClassName={styles.primarySaveButton}
          actionLoading={updateLoading}
          actionDisabled={disableUpdate}
          actionSecondaryText={locale.cancel}
          actionSecondaryOutlined
          actionSecondaryOnClick={() => {
            history.push(Path.ViewCompetitor, {
              brandId,
              updatedAt,
            });
          }}
          actionSecondaryClassName={styles.secondarySaveButton}
        />
        <CompetitorDetailsModule
          pageMode={FormMode.Edit}
          {...successModal}
          brandId={brandId}
          setUpdateLoading={setUpdateLoading}
          setDisableUpdate={setDisableUpdate}
          ref={competitorDetailsRef}
        />
      </div>
    </div>
  );
};

export default CompetitorEditModule;
